<template>
   <div id="Works">

     <div ref="loading_cover" class="loading-cover"><div class="center-spin"><b-spinner variant="danger" label="Spinning"></b-spinner></div></div>

      <bg-pattern-div :imgSrc="patternImgSrc" zIndex="-99" :opacity="opacity_bg"></bg-pattern-div>
      <section class="works-section">
        <div class="title">FILMS CASES</div>
        <div class="container list category-container"> 
          <div class="row justify-content-center">
            <template v-for="(c, index) in categories" >
                <div class="col-md-auto fit-content" :id="c.pk" :key="index"><button @click="categoryOnClick" class="c-btn">{{c.fields.category_name}}</button></div>
            </template>
          </div>
        </div>
        <div class="container list"> 
          <div class="row justify-content-center">            
              <list-item v-for="(p) in projects" :itemTitle="p.project_name" :itemImgSrc="p" :key="p.pk"></list-item>
          </div>
        </div>
    </section>

    <div class="mt-3 page-container">
      <b-pagination @change="onPageChange" v-model="currentPage" :total-rows="rows" pills :per-page="perPage" align="center">
        <template v-slot:first-text><b-icon-arrow-left></b-icon-arrow-left></template>
        <template v-slot:last-text><b-icon-arrow-right></b-icon-arrow-right></template>
      </b-pagination>

    </div>
    </div>
  <!-- <div class="page-container" id="WorksPage">
    
    
    

  </div> -->
</template>

<script>
// @ is an alias to /src
import BgPatternDiv from "../components/BgPatternDiv.vue"
import ListItem from "../components/ListItem.vue"
import { BIconArrowLeft, BIconArrowRight,} from 'bootstrap-vue'

const axios = require('axios').default;
var hostName = "";
//const hostNuame = location.hostname; 
var api_host = "https://" + hostName + "/admin/api/";
var api_get_categories = api_host + "get_categories";
var api_get_projects = api_host + "get_project";
const page_size_num = 9;

export default {
  name: 'Works',
  data() {
      return {
        rows: 100,
        perPage: 3,
        currentPage: 1,
        prevClass: null,
        patternImgSrc:"../assets/bg_pattern.jpg",
        opacity_bg: 1,
        projects: null,
        categoriesDict: {},
        cDictChoose:{},
        c:[],
        categories: null,
        categories_choose:[],
      }
  },
  metaInfo(){

    return{
      title: "路人甲影像-作品集",
      meta: [
                {charset: 'utf-8'}, 
                {name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0' },
                {name: 'description', content: '某次與路人擦肩而過，你突然意識到自己的渺小，回想起在咖啡廳看窗外的行人走過，在等紅綠燈時看著車來人往，你發現自己跟他們一樣，沒什麼特別，但其實他們也跟你一樣，有著獨一無二的經歷，複雜的情感，豐富的生活。你是路人甲，你也是Somebody，我們要在新時代跳脫思維，創造獨一無二的影像魅力，傳達深刻人心的故事精神。我們是 路人甲影像 Somebody films。'},
                {property: 'og:title', content: '路人甲影像-作品集'},
                {property: 'og:site_name', content: '路人甲影像'},
                {property: 'og:description', content: '某次與路人擦肩而過，你突然意識到自己的渺小，回想起在咖啡廳看窗外的行人走過，在等紅綠燈時看著車來人往，你發現自己跟他們一樣，沒什麼特別，但其實他們也跟你一樣，有著獨一無二的經歷，複雜的情感，豐富的生活。你是路人甲，你也是Somebody，我們要在新時代跳脫思維，創造獨一無二的影像魅力，傳達深刻人心的故事精神。我們是 路人甲影像 Somebody films。'},
                {property: 'og:type', content: 'website'},
                {property: 'og:url', content: 'https://' + location.hostname + '/Projects'},
                {property: 'og:image', content: 'https://storage.googleapis.com/sb_web_site/fb_1200x630.jpg' }    
            ]
    }

  },
  methods: {
    hideCover: function(){
      this.$refs.loading_cover.className = "loading-cover finish";
    },
    categoryOnClick : function(event){
      let cTarget = event.target;
      this.c = [];
      if(cTarget.className == "c-btn"){
        cTarget.className = "c-btn active"
        this.cDictChoose[cTarget.parentElement.id] = this.categoriesDict[cTarget.parentElement.id];
      }else{
        cTarget.className = "c-btn"
        delete this.cDictChoose[cTarget.parentElement.id];
      }

      for (var key in this.cDictChoose) {
         
          this.c.push(key);
      }

      this.onPageChange(1);
      
    },
    onPageChange : function(pageNum){
      console.log(pageNum + " " + this.currentPage);
      let self = this;
      //this.projects = [];
      axios({
              method: 'get',
              url: api_get_projects,
              params: {
                page_size: page_size_num,
                page: pageNum,
                c: self.c.join(','),
              },
              //headers: headers
          })
          .then(function (response) {
              //handle success
              
              let response_data = response.data;
              var projectsData = response_data.results;
              for(var i = 0 ; i < projectsData.length ; i++){
                var projectObj = projectsData[i];
                var picDatas = JSON.parse(projectObj.project_edit_result);
                projectsData[i].pics = picDatas;
              }
              self.projects = projectsData;
              self.rows = parseInt(response_data.total)
              self.perPage = parseInt(response_data.page_size);
              self.currentPage = parseInt(response_data.page);
              
              window.scrollTo(0, 0);
              
          })
          .catch(function (response) {
              //handle error
              console.log(response);

          });
      

    },
  },
  created() {

    hostName = this.$apiHost;
    //const hostNuame = location.hostname; 
    api_host = "https://" + hostName + "/admin/api/";
    api_get_categories = api_host + "get_categories";
    api_get_projects = api_host + "get_project";

  },
  computed: {
      // rows() {
      //   return 30;
      // }
      getPrevClass (){
        return null;
      },

      getContent (){
        return null;
      }
  },
  components: {
    BgPatternDiv,
    BIconArrowLeft,
    BIconArrowRight,
    ListItem,
  },
  mounted() {
    
    
    this.$nextTick(()=>{
      
      let self = this;
      this.$emit('onViewReady', this.$route.name);
      this.$refs.loading_cover.className = "loading-cover";

      axios
          .get(api_get_categories)
          .then((response) => {
              let response_data = response.data;
              self.categories = response_data.categories;
              
              for(var i = 0 ; i < response_data.categories.length ; i++){
                var cateDataObj = response_data.categories[i];
                self.categoriesDict[cateDataObj.pk] = cateDataObj.fields.category_name;

              }
              console.log("dict:");
              console.log(self.categoriesDict);

              axios({
                        method: 'get',
                        url: api_get_projects,
                        params: {
                          page_size: page_size_num,
                          page: this.currentPage,
                          c: this.c.join(','),
                        },
                        //headers: headers
                    })
                    .then(function (response) {
                        //handle success
                        console.log(response.data);
                        let response_data = response.data;
                        let link = response_data.links;
                        console.log(link);
                        self.rows = parseInt(response_data.total)
                        console.log(self.rows);
                        self.perPage = parseInt(response_data.page_size);
                        self.currentPage = parseInt(response_data.page);
                        var projectsData = response_data.results;

                        for(var i = 0 ; i < projectsData.length ; i++){
                          var projectObj = projectsData[i];
                          var picDatas = JSON.parse(projectObj.project_edit_result);
                          projectsData[i].pics = picDatas;
                        }

                        console.log(projectsData)
                        self.projects = projectsData;

                        window.scrollTo(0, 0);
                        setTimeout(self.hideCover,1500);
                        
                    })
                    .catch(function (response) {
                        //handle error
                        console.log(response);
                    });


              //Vue.$cookies.set('csrftoken',index_data.csfr);
              
                  
          })




      
    });
   
    
    
  },
}
</script>

<style lang="sass" scoped>

  @import '../assets/works.sass'
</style>
